import QualityControlStore from "./QualityControl/QualityControlStore";
import QualityControlDemoStore from "./mocks/QualityControlDemoStore";

const qualityControlStoreList = [
    { name: "qualityControlStore", store: QualityControlStore },
    { name: "qualityControlDemoStore", store: QualityControlDemoStore },
];

export default qualityControlStoreList;
